import { Component, OnInit } from '@angular/core';
import { GlobalComponent } from '../../global-component';

@Component({
  selector: 'app-maintenance',
  templateUrl: './maintenance.component.html',
  styleUrls: ['./maintenance.component.scss']
})

/**
 * Maintenance Component
 */
export class MaintenanceComponent implements OnInit {

  // set the current year
  copyright = GlobalComponent.strings.copyright;

  constructor() { }

  ngOnInit(): void {
    document.documentElement.setAttribute('data-sidebar-size', 'lg');
  }

}
